import { FC, useCallback } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Save } from '@mui/icons-material';

import { useRouter } from '@cvt/routing';
import { useDictionary } from '@cvt/hooks/useDictionary';

import { useMeetingCrud } from '../hooks/useMeetingCrud';

import { FormCrud, MeetingForm } from './MeetingForm/MeetingForm';


interface ViewProps {
  onSuccess?: (meeting: Meetings.Meeting) => void;
}

export const CreateMeetingPartial: FC<ViewProps> = (props) => {
  const { onSuccess } = props;
  const router = useRouter();
  const dictionary = useDictionary();

  const { createMeeting } = useMeetingCrud();

  const onSubmit = useCallback(async (data: FormCrud) => {
    try {
      const response = await createMeeting.mutateAsync(data);
      onSuccess?.(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [createMeeting, onSuccess]);

  return (
    <Stack gap={2} width="100%">
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={2} alignItems="center">
        <Button variant="outlined" color="primary" onClick={() => router.meetings.go()}>
          Back to Meetings
        </Button>
        <Stack>
          <Typography variant="body1" fontSize={30} fontWeight={600} textAlign={{ xs: 'center', sm: 'left' }}>
            {dictionary.meetings.create.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" fontSize={16} textAlign={{ xs: 'center', sm: 'left' }}>
            {dictionary.meetings.create.subtitle}
          </Typography>
        </Stack>
      </Stack>

      <MeetingForm
        onSubmitRequest={onSubmit}
        slots={{
          footer: (formState) => (
            <Stack direction={{ xs: 'column-reverse', sm: 'row' }} justifyContent="flex-end" width="100%" gap={2}>
              <Button
                variant="outlined"
                color="primary"
                type="button"
                size="large"
                onClick={() => router.meetings.go()}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                startIcon={<Save/>}
                loading={formState.isSubmitting}
              >
                Save Meeting
              </LoadingButton>
            </Stack>
          ),
        }}
      />
    </Stack>
  );
};
